import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useTaskStore } from '@/stores/task'
import { useScheduleStore } from '@/stores/schedule'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    component: () => import('@/views/MainLayout/index.vue'),
    meta: { auth: true },
    redirect: '/workbench',
    children: [
      {
        path: 'workbench',
        name: 'workbench',
        component: () => import('@/views/Workbench/index.vue'),
      },
      {
        path: 'schedule',
        name: 'schedule',
        component: () => import('@/views/Schedule/index.vue'),
      },
      {
        path: 'aigc',
        name: 'aigc',
        component: () => import('@/views/Aigc/index.vue'),
      },
      {
        path: 'projects',
        name: 'projects',
        component: () => import('@/views/ProjectManagement/index.vue'),
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/views/AccountManagement/index.vue'),
        meta: { admin: true },
      },
      {
        path: 'account/users',
        name: 'accountUsers',
        component: () => import('@/views/AccountManagement/UsersPage.vue'),
        meta: { admin: true },
      },
      {
        path: 'account/departments',
        name: 'accountDepartments',
        component: () => import('@/views/AccountManagement/DepartmentsPage.vue'),
        meta: { admin: true },
      },
      {
        path: 'account/positions',
        name: 'accountPositions',
        component: () => import('@/views/AccountManagement/PositionsPage.vue'),
        meta: { admin: true },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

let storesInitialized = false

async function ensureStoresInitialized() {
  if (storesInitialized) return
  storesInitialized = true
  const taskStore = useTaskStore()
  const scheduleStore = useScheduleStore()
  await Promise.all([taskStore.init(), scheduleStore.init()])
}

router.beforeEach(async (to) => {
  const user = useUserStore()
  if (to.meta.auth && !user.isLoggedIn) {
    if (user.token && !user.initialized) {
      try {
        await user.fetchProfile()
        await ensureStoresInitialized()
      } catch {
        storesInitialized = false
        return { name: 'login' }
      }
    } else {
      return { name: 'login' }
    }
  }
  if (user.isLoggedIn && !storesInitialized) {
    await ensureStoresInitialized()
  }
  if (to.meta.guest && user.isLoggedIn) return { name: 'workbench' }
  if (to.meta.admin && !user.isAdmin) return { name: 'workbench' }
  return true
})

export default router
